import Vue from "vue";
import Router from "vue-router";
// import NProgress from "nprogress";
// import { getToken } from "@/utils/auth";
// import layout from "@/views/layout";
// import { native } from "@/utils/hybrid";
// import { browser } from "@/utils";

// import partner from "./partner";
// import activity from "./activity";
// import hybrid from "./hybrid";
// import pagesRouter from "./pagesRouter";
// import demos from "./demos";

Vue.use(Router);

const routes = [
  {
    name: "index",
    path: "/"
    // redirect: "/partner"
    // component: () => import("@/views/download")
  },
  {
    name: "biz",
    path: "/biz",
    component: {
      render: h => h("router-view")
    },
    children: [
      {
        name: "biz.app",
        path: "app",
        component: () => import("@/views/biz/app"),
        meta: {
          title: "小灵狗企业App"
        }
      }
    ]
  },
  {
    path: "*",
    redirect: "/"
  }
];

// add route path
// routes.forEach(route => {
//   route.path = route.path || "/" + (route.name || "");
// });

const router = new Router({
  // mode: "history",
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  }
});

// NProgress.configure({
//   showSpinner: false
// }); // NProgress Configuration

router.beforeEach((to, from, next) => {
  // NProgress.start(); // start progress bar
  // console.log(to, from);
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});
router.afterEach(() => {
  // NProgress.done(); // finish progress bar
});

export { router };
